import React from 'react'
import { Button } from 'antd'

export default function ButtonComponent ({ children, onClick }) {
  return (
    <Button onClick={onClick} className='button-link'>
      {children}
    </Button>
  )
}
